import { ActivityFactory, Activity, ActivityFactoryError, ActivityCode, ActivityName } from '@/Domain/Activities'
import { AxiosActivityData } from '@/Infrastructure/Activities/Persistence/Axios'

export class AxiosActivityFactory implements ActivityFactory<AxiosActivityData> {
  makeActivity (data: AxiosActivityData): Activity {
    try {
      return new Activity(new ActivityCode(data.code), new ActivityName(data.name))
    } catch (error) {
      throw new ActivityFactoryError(error.message)
    }
  }
}
